/**
 * @desc 节假日管理保存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  body: defs.basics.HolidayManagementCreateRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/holidayManagement/saveOrUpdate`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
